import { useState, useCallback, useRef, useEffect } from 'react';
import Select from '../Select/Select';

const defaultFormatOption = (item) => {
  return { value: item.id, label: item.title };
};

/**
 * @param resetKey â Ð²Ð½ÐµÑÐ½Ð¸Ð¹ ÑÐ¸Ð»ÑÑÑ ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸ÐºÐ° (Ð½Ð°Ð¿ÑÐ¸Ð¼ÐµÑ Ð²ÑÐ±ÑÐ°Ð½Ð½Ð°Ñ Ð¼Ð°ÑÐºÐ°).
 *   ÐÐµÐ½ÑÐµÑÑÑ â Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÐ¹ ÑÐ¿Ð¸ÑÐ¾Ðº Ð±Ð¾Ð»ÑÑÐµ Ð½Ðµ Ð²ÐµÑÐµÐ½, Ð·Ð°Ð±ÑÐ²Ð°ÐµÐ¼ ÐµÐ³Ð¾.
 */
const SelectWithFetch = ({
  handleSetSelect,
  handleSetState,
  style,
  fetch,
  formatOption = defaultFormatOption,
  resetKey,
  ...props
}) => {
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // Ð¤Ð»Ð°Ð³, Ð° Ð½Ðµ options.length: ÑÐ¿ÑÐ°Ð²Ð¾ÑÐ½Ð¸Ðº Ð¸Ð¼ÐµÐµÑ Ð¿ÑÐ°Ð²Ð¾ Ð²ÐµÑÐ½ÑÑÑ Ð¿ÑÑÑÐ¾Ð¹ ÑÐ¿Ð¸ÑÐ¾Ðº,
  // Ð¸ Ð¿Ð¾ Ð´Ð»Ð¸Ð½Ðµ ÑÐ°ÐºÐ¾Ð¹ Ð¾ÑÐ²ÐµÑ Ð½Ð°Ð²ÑÐµÐ³Ð´Ð° Ð¾ÑÑÐ°Ð²Ð°Ð»ÑÑ Ð±Ñ Â«ÐµÑÑ Ð½Ðµ Ð·Ð°Ð³ÑÑÐ¶ÐµÐ½Ð½ÑÐ¼Â» â
  // ÐºÐ°Ð¶Ð´Ð¾Ðµ Ð¾ÑÐºÑÑÑÐ¸Ðµ Ð¼ÐµÐ½Ñ ÑÑÐ½ÑÐ»Ð¾ Ð±Ñ ÐµÐ³Ð¾ Ð·Ð°Ð½Ð¾Ð²Ð¾.
  const loadedRef = useRef(false);
  const onFocus = useCallback(() => {
    if (isLoading || loadedRef.current) return;
    loadedRef.current = true;
    setIsLoading(true);
    fetch().then((res) => {
      const options = res.data.map(formatOption);
      setOptions(options);
    }).catch(() => {
      // ÐÐ°ÑÑ Ð¿Ð¾Ð²ÑÐ¾ÑÐ¸ÑÑ Ð¿Ð¾Ð¿ÑÑÐºÑ Ð¿ÑÐ¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐ¼ Ð¾ÑÐºÑÑÑÐ¸Ð¸: Ð¸Ð½Ð°ÑÐµ Ð¾Ð´Ð½Ð° ÑÐµÑÐµÐ²Ð°Ñ
      // Ð¾ÑÐ¸Ð±ÐºÐ° Ð¾ÑÑÐ°Ð²Ð¸Ð»Ð° Ð±Ñ Ð¿Ð¾Ð»Ðµ Ð¿ÑÑÑÑÐ¼ Ð´Ð¾ Ð¿ÐµÑÐµÐ·Ð°Ð³ÑÑÐ·ÐºÐ¸ ÑÑÑÐ°Ð½Ð¸ÑÑ.
      loadedRef.current = false;
    }).finally(() => setIsLoading(false));
  }, [fetch, formatOption, isLoading]);

  useEffect(() => {
    loadedRef.current = false;
    setOptions([]);
  }, [resetKey]);

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      onFocus={onFocus}
      style={style}
      isLoading={isLoading}
      {...props}
    />
  );
};

export default SelectWithFetch;
